import React, { useState, useEffect } from "react"
// import { Link } from "gatsby"
import cheerio from "cheerio"
import hljs from "highlight.js"
import "highlight.js/styles/atom-one-dark.css"

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"

import * as Styles from "./index.module.scss"
import "react-accessible-accordion/dist/fancy-example.css"

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LineShareButton,
  LineIcon,
  HatenaShareButton,
  HatenaIcon,
} from "react-share"
import { commonSmoothScroll } from "@/components/commonSmoothScroll"

export type ShortCode = {
  code: string
  body: string
}

type ReplaceBody = {
  body: string
  shortCodes?: ShortCode[]
}

export const replaceBody = ({ body, shortCodes }: ReplaceBody): string => {
  const shortCodesMap =
    shortCodes?.reduce<Record<string, string>>(
      (res, { code, body }) => ({ ...res, [code]: body }),
      {}
    ) ?? {}

  return body.replace(/&lt;&lt;(.+?)&gt;&gt;/g, (...[, key]) => {
    return shortCodesMap[key]
  })
}

export const Article: React.VFC<GatsbyTypes.BlogPostQuery> = ({
  microcmsBlog,
}) => {
  const categories = microcmsBlog?.category
  const block = microcmsBlog?.block
  const [url, setUrl] = useState("")
  let rewriteBody = ""

  const reBody = replaceBody(microcmsBlog)

  useEffect(() => {
    setUrl(location.href)
  }, [])

  // 目次表示
  const $ = cheerio.load(reBody as string)

  // 見出しタグの取得
  const headings = $("h1, h2, h3, h4").toArray()
  const toc = headings.map(data => {
    const headingTag = data as cheerio.TagElement
    return {
      text: headingTag.children[0].data,
      id: headingTag.attribs.id,
      name: headingTag.name,
    }
  })

  // codeタグの取得
  $("pre code").each((_, elm) => {
    const result = hljs.highlightAuto($(elm).text())
    $(elm).html(result.value)
    $(elm).addClass("hljs")
  })

  rewriteBody = $.html()
  commonSmoothScroll()

  return (
    <>
      <div className={Styles.main}>
        <h1>{microcmsBlog?.title}</h1>
        <div className={Styles.infoWrap}>
          <div className={Styles.dateContainer}>
            <div className={Styles.date}>{microcmsBlog?.date}</div>
            <div className={Styles.snsContainer}>
              <FacebookShareButton
                className={Styles.snsItem}
                title={microcmsBlog?.title + "\n"}
                url={url}
              >
                <FacebookIcon round size={25} />
              </FacebookShareButton>
              <TwitterShareButton
                className={Styles.snsItem}
                title={microcmsBlog?.title + "\n"}
                url={url}
              >
                <TwitterIcon round size={25} />
              </TwitterShareButton>
              <LineShareButton
                className={Styles.snsItem}
                title={microcmsBlog?.title + "\n"}
                url={url}
              >
                <LineIcon round size={25} />
              </LineShareButton>
              <HatenaShareButton title={microcmsBlog?.title + "\n"} url={url}>
                <HatenaIcon round size={25} />
              </HatenaShareButton>
            </div>
          </div>
          <div>
            {categories?.map((category, index: number) => {
              return (
                <div key={index} className={Styles.category}>
                  #{category?.name}
                </div>
              )
            })}
          </div>
        </div>
        <div className={Styles.toc}>
          {toc[0] ? (
            <ul className={Styles.tocList}>
              {toc.map(data => (
                <li key={data.id} className={Styles[data.name]}>
                  <a href={"#" + data.id}>{data.text}</a>
                </li>
              ))}
            </ul>
          ) : null}
        </div>

        {/* 関連記事カード */}
        {/* <div>
          {block
            ? block.map((item, i: number) => {
                if (item?.fieldId === "blogBody") {
                  return (
                    <div
                      key={i}
                      dangerouslySetInnerHTML={{ __html: item.text as string }}
                    />
                  )
                } else if (item?.fieldId === "ogp_card") {
                  const meta = item.ogp_card
                  return (
                    <Link to={`/blog/${meta?.id}`} key={i}>
                      <div className={Styles.ogpCard}>
                        <figure className={Styles.ogpImg}>
                          <img src={meta?.img?.url} alt={meta?.title} />
                        </figure>
                        <div className={Styles.ogpTextWrap}>
                          <p className={Styles.ogpTitle}>{meta?.title}</p>
                          <p className={Styles.ogpText}>{meta?.excerpt}</p>
                        </div>
                      </div>
                    </Link>
                  )
                }
              })
            : null}
        </div> */}

        {/* 関連記事カード */}

        <div dangerouslySetInnerHTML={{ __html: rewriteBody }} />
        <div className={Styles.faq}>
          {block
            ? block.map((item, i: number) => {
                if (item?.fieldId === "faq") {
                  const qa_list = item.qa_list
                  return (
                    <Accordion allowMultipleExpanded allowZeroExpanded key={i}>
                      {qa_list?.map((qa, j: number) => {
                        const $ans = cheerio.load(qa?.answer as string)
                        $ans("pre code").each((_, elm) => {
                          const result = hljs.highlightAuto($(elm).text())
                          $ans(elm).html(result.value)
                          $ans(elm).addClass("hljs")
                        })
                        return (
                          <AccordionItem key={j}>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                {qa?.question}
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              {" "}
                              <div
                                key={j}
                                dangerouslySetInnerHTML={{
                                  __html: $ans.html() as string,
                                }}
                              />
                            </AccordionItemPanel>
                          </AccordionItem>
                        )
                      })}
                    </Accordion>
                  )
                }
              })
            : null}
        </div>
        <div className={Styles.share}>
          <p className={Styles.shareText}>この記事をシェアする</p>
          <div className={Styles.snsContainer}>
            <FacebookShareButton
              className={Styles.snsItem}
              title={microcmsBlog?.title + "\n"}
              url={url}
            >
              <FacebookIcon round size={45} />
            </FacebookShareButton>
            <TwitterShareButton
              className={Styles.snsItem}
              title={microcmsBlog?.title + "\n"}
              url={url}
            >
              <TwitterIcon round size={45} />
            </TwitterShareButton>
            <LineShareButton
              className={Styles.snsItem}
              title={microcmsBlog?.title + "\n"}
              url={url}
            >
              <LineIcon round size={45} />
            </LineShareButton>
            <HatenaShareButton title={microcmsBlog?.title + "\n"} url={url}>
              <HatenaIcon round size={45} />
            </HatenaShareButton>
          </div>
        </div>
      </div>
    </>
  )
}
